import React     from 'react'
import PropTypes from 'prop-types'

import ActionButton from '../components/ActionButton'

import api from '../redux/api'

export default class RetryButton extends React.Component {
  static propTypes = {
    job:          PropTypes.object.isRequired,
    history:      PropTypes.object.isRequired,
    forceRetry:   PropTypes.bool
  }

  handleRetry = () => {
    return api.retryJob({
      jobId:      this.props.job.id,
      forceRetry: this.props.forceRetry,
     })
  }

  handleRetryComplete = (result) => {
    this.props.history.push(`/jobs/item/${result.jobId}`)
  }
  
  render() {
    const { job } = this.props

    const retryTitle  = job.title
      ? `Are you sure to retry "${job.title}" job?`
      : 'Are you sure to retry the job?'
      
    return (
      <ActionButton
        buttonIconName="redo"
        onPerformAction={this.handleRetry}
        onPerformActionComplete={this.handleRetryComplete}
        buttonText="Retry"
        confirmationTitle={retryTitle}
        confirmationHeader="Retry job"
      />
    )
  }
}
